import { Compass, Languages, Handshake, Zap } from "lucide-react";

const reasons = [
    {
        icon: Compass,
        title: "Tahu konteks Papua",
        desc: "Berbasis di Abepura. Paham kebiasaan pelanggan lokal, koneksi internet, hingga preferensi visual.",
    },
    {
        icon: Languages,
        title: "Komunikasi tanpa jargon",
        desc: "Semua dijelaskan dalam Bahasa Indonesia yang lugas. Tidak ada istilah teknis yang membingungkan.",
    },
    {
        icon: Handshake,
        title: "Harga ramah UMKM",
        desc: "Skema yang menyesuaikan skala usaha — dari yang baru mulai sampai yang ingin scale up.",
    },
    {
        icon: Zap,
        title: "Cepat dan tetap rapi",
        desc: "Rata-rata website siap rilis dalam 4–10 hari kerja, tanpa mengorbankan kualitas.",
    },
];

export const WhyUs = () => {
    return (
        <section
            data-testid="why-us-section"
            className="py-20 md:py-32 relative"
        >
            <div className="max-w-7xl mx-auto px-5 md:px-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16 md:mb-20">
                    <div className="col-span-1 md:col-span-5">
                        <div className="text-xs uppercase tracking-[0.3em] text-jws-muted mb-4">
                            (04) Mengapa kami
                        </div>
                        <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1]">
                            Dikerjakan
                            <br />
                            <span className="italic text-jws-primary">
                                satu tangan
                            </span>
                            ,<br />
                            dengan rasa peduli.
                        </h2>
                    </div>
                    <div className="col-span-1 md:col-span-6 md:col-start-7 md:pt-4">
                        <p className="text-base md:text-xl text-jws-muted leading-relaxed">
                            Saya bukan agensi besar dengan banyak lapis tim. Setiap proyek
                            dikerjakan langsung — dari obrolan pertama, desain, koding,
                            sampai launching. Anda berbicara dengan orang yang sama,
                            yang benar-benar tahu detail website anda.
                        </p>
                        <p className="mt-5 md:mt-6 text-sm md:text-base text-jws-muted leading-relaxed">
                            Filosofinya sederhana: kalau saya yang kerjakan, saya yang
                            tanggung jawab. Tidak ada lempar tangan. Tidak ada slide
                            presentasi yang muluk-muluk. Yang ada hanya hasil kerja yang
                            bisa anda lihat dan rasakan dampaknya untuk usaha anda.
                        </p>
                    </div>
                </div>

                {/* Reasons grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-jws-border border border-jws-border rounded-2xl overflow-hidden">
                    {reasons.map((r) => {
                        const Icon = r.icon;
                        return (
                            <div
                                key={r.title}
                                data-testid={`why-${r.title.split(" ")[0].toLowerCase()}`}
                                className="bg-jws-bg p-7 md:p-9 flex flex-col"
                            >
                                <div className="h-11 w-11 grid place-items-center rounded-xl bg-jws-ochre/20 text-jws-primary">
                                    <Icon className="h-5 w-5" />
                                </div>
                                <h3 className="mt-8 font-display text-xl md:text-2xl tracking-tight">
                                    {r.title}
                                </h3>
                                <p className="mt-3 text-jws-muted leading-relaxed text-sm">
                                    {r.desc}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
